<template>
    <!-- 关于我们 -->
    <el-container class="aboutus">
        <!-- <el-header :height="'70'">
            <home-header :opacity="opacity"></home-header>
        </el-header> -->
        <el-main>
            <div class="maintop">
                <div class="titlecon">
                    <div class="cn"><h3 style="font-size:18px">关于我们</h3></div>
                    <div class="en">About us</div>
                </div>
            </div>
            <div class="mainbottom">
                <div class="bigimg">
                  <img src="../../static/images/icon/abuoutus.jpg">
                </div>
                <div class="textdesc">
                    <!-- <h3 style="font-size:18px;margin-bottom:40px">中山日报新传媒简介</h3> -->
                    <h4>Brand——“南方视觉影像库”</h4>
                    <p>
                        南方视觉公司由中国省级党报领跑者、中国新闻改革风向标——南方日报和视觉内容版权服务行业全球领导者——视觉中国集团两大主要股东联手打造的华南地区大型权威图片版权交易平台。为摄影、媒体、广告等视觉生态从业者提供全方位的图片代理销售、内容策划、编辑整合及视觉技术管理等服务。
                    </p>
             
                    <h4>Authority——“广东本土最大图片版权交易平台”</h4>
                    <p>
                      南方视觉图片库以图片影像图建设为核心，依托南方报业68年积累的海量内容数据，联手广东各地摄影记者、摄影协会、摄影爱好者，为“南方视觉影像库”交易平台输送图片资料，将“南方视觉影像库”的图片数量迅速充实至亿级，成为广东本地最专业、最权威、全覆盖的影像交易平台。
                    </p>
                    <h4>Comprehensive——“一站式的视觉服务平台”</h4>
                    <p>
                      南方视觉确立“视觉+”发展战略，在图片库技术、图像识别、搜索算法、智能大数据分析、云服务等方面不断创新，为地方政府、企事单位建设自己的“图片库”，为媒体、企业、广告公司、制作公司等各类客户提供专业的图片、影视、音乐、特约拍摄、创意众包，及以视觉为核心的整合营销等一站式服务。
                    </p>
                    <h4>Professional——“比之预想，更加理想”</h4>
                    <p>
                      广东南方视觉传媒有限公司拥有先进的视觉制作场地、专业设备和一流人才。在广州南方报业集团289创意园设有影棚、虚拟演播厅、影视后期制作中心等。依托南方日报视觉新闻部的专业团队，拥有专业摄影师（航拍）、动画制作师、平面设计师、视频剪辑师等技术骨干，还成立以南方日报摄影师团队为主的首个无人机全景影像制作团队。
                    </p>
                    <h4>Quality——“不一样的眼光，成就您不一样的辉煌”</h4>
                    <p>
                      广东南方视觉传媒有限公司还拥有强大的传播矩阵和合作资源，如广东摄影家协会、百度地图和12301智慧旅游平台等战略合作伙伴。公司将搭建自己的视觉图片库，可为华南地区政府机构、企事业单位等各类客户提供各种以视觉务核心的整合营销等一站式服务，如新媒体动画制作设计、短视频节目摄制包装、活动摄影、微信H5、政务画册等。
                    </p>
                </div>
            </div>
        </el-main>
        <el-footer v-if="hidefooter" style="height:316px">
            <home-footer></home-footer>
        </el-footer>
    </el-container>
</template>
<script>

import homeHeader from "../components/homeHeader.vue"; //头部
import homeHeaderAd from "../components/homeHeaderAd.vue"; //头部
import homeFooterAd from "../components/homeFooterAd.vue"; //底部
import homeFooter from "../components/homeFooter.vue"; //底部
import {mapGetters,mapActions} from 'vuex';
export default {
  components: {
    homeHeader,
    homeHeaderAd,
    homeFooterAd,
    homeFooter
  },
  data() {
    return {
      opacity: "0.68"
    };
  },
  computed:{
    ...mapGetters(['hidefooter'])
  },
  mounted(){
      window.addEventListener("scroll", this.mosewheel, true);
  },
  methods: {
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    }
  }
};
</script>
<style lang="less">
.aboutus {
  .el-main {
    padding: 0px !important;
    .maintop {
      background-color: #ea4d46;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      .titlecon {
        color: white;
        .en {
          text-align: center;
        }
        .cn {
          font-size: 18px;
          text-align: center;
        }
      }
    }
    .mainbottom {
      padding: 50px 50px;
      .bigimg {
        width: 900px;
        margin: 0 auto;
        border-radius: 5px;
        img{
          width: 100%;
        }
      }
      .textdesc {
        width: 1200px;
        margin: 50px auto;
        h3 {
          text-align: center;
        }
        h4{
          margin-top: 20px;
          // font-size: 14px;
          margin-bottom: 10px;
          // text-align: center
        }
        p {
          font-size: 12px;
          margin-bottom: 20px;
          color: #6f6f6f;
          text-indent: 2em;
        }
      }
    }
  }
  .el-footer {
    padding: 0px;
  }
}
</style>









// WEBPACK FOOTER //
// src/page/aboutUs.vue